import React, {useState} from 'react';
import Modal from "react-modal";
import {Col, Container, Row} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./ConfirmModalStyle.css";

const modalStyle = {
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    content: {
        color: 'black',
        width: '500px',
        height: '150px',
        margin: 'auto',
        borderRadius: '15px'
    }
};

const ConfirmModal = ({ isOpen, setIsOpen, title, confirmLabel, rejectLabel, onConfirm, onReject, isLoading = false }) => {
    const { t } = useTranslation();

    return (
        <Modal
            style={modalStyle}
            isOpen={isOpen}
            onRequestClose={() => {
                if (!isLoading) {
                    onReject();
                    setIsOpen(false);
                }
            }}
        >
            <div
                style={{
                    width: '100%'
                }}
            >
                <Container fluid>
                    <Row>
                        <div
                            style={{
                                width: '100%',
                                textAlign: 'center',
                                height: '80px',
                                overflow: 'auto'
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '16px',
                                    color: '#696969'
                                }}
                            >
                                {title}
                            </span>
                        </div>
                    </Row>
                    <Row
                        style={{
                            marginTop: '5px'
                        }}
                    >
                        <Col>
                            <button
                                className={"modal-confirmBtn"}
                                onClick={() => {
                                    if (!isLoading) {
                                        setIsOpen(false);
                                        onConfirm();
                                    }
                                }}
                                disabled={isLoading}
                                style={{
                                    opacity: isLoading ? 0.6 : 1,
                                    cursor: isLoading ? 'not-allowed' : 'pointer'
                                }}
                            >
                                {isLoading ? t("button.processing") : confirmLabel}
                            </button>
                        </Col>
                        <Col>
                            <button
                                className={"modal-rejectBtn"}
                                onClick={() => {
                                    if (!isLoading) {
                                        setIsOpen(false);
                                        onReject();
                                    }
                                }}
                                disabled={isLoading}
                                style={{
                                    opacity: isLoading ? 0.6 : 1,
                                    cursor: isLoading ? 'not-allowed' : 'pointer'
                                }}
                            >
                                {rejectLabel}
                            </button>
                        </Col>
                    </Row>
                </Container>
            </div>
        </Modal>
    );
};

export default ConfirmModal;